import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	cartData: [],
	subtotal: 0,
	isLoading: false,
	hasBeenLoaded: false,
	error: undefined
};

export const cartSlice = createSlice({
	name: 'cart',
	initialState,
	reducers: {
		addItemToCart: (state, action) => {
			const entryExists = state.cartData.findIndex((item) => item.id === action.payload?.id);

			if (entryExists !== -1) {
				if (state.cartData[entryExists].quantity && action.payload.quantity) {
					state.cartData[entryExists].quantity = action.payload.quantity;
				} else {
					state.cartData[entryExists].quantity++;
				}
			} else {
				state.cartData.push({ ...action.payload, quantity: action.payload?.quantity || 1 });
			}
		},
		generateSubtotal: (state) => {
			let subtotal = 0;

			state.cartData.forEach((item) => {
				subtotal += item.price * item?.quantity || item.price;
			});

			state.subtotal = subtotal;
		},
		removeItemFromCart: (state, action) => {
			state.cartData = state.cartData.filter((item) => item.id !== action.payload);
		},
		updateItemsInCart: (state, action) => {
			state.cartData = initialState.cartData;
			state.cartData = action.payload;
		}
	}
});

export const {
	addItemToCart,
	generateSubtotal,
	removeItemFromCart,
	updateItemsInCart
} = cartSlice.actions;

export default cartSlice.reducer;
